import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

const FEATURES = {
  GENERIC: ``,
  CUSTOM_EVENTS: `custom-events`,
  DATE_RANGE: `date-range`,
  EXPORT_CSV: `export-csv`,
  FILTER_LEVELS: `filter-levels`,
  BOOKMARK_MAXIMUM: `bookmark-maximum`,
  PROJECTS: `projects`,
};

class UpsellPopup extends Component<{}> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      feature: {type: `string`, enum: Object.values(FEATURES)},
      open: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        FEATURES,
        handleModalChange: (ev) => this.dispatchEvent(new CustomEvent(`change`, {detail: ev.detail})),
      },
    };
  }
}

export default registerMPElement(`mp-upsell-popup`, UpsellPopup);
